export default "__VITE_ASSET__cd41c17b__"